import { queryKeys } from "@healthos/client-data";
import type { api } from "@healthos/schemas";
import { useQuery } from "@tanstack/react-query";
import { client, jsonOrThrow } from "../../api/healthos";

/**
 * Whether this member may see the Tweaks panel and use the overrides it sets.
 *
 * Always true in a DEV build. Otherwise the server answers from the
 * member-scoped `enableTweaksPanel` flag. `undefined` while the answer is
 * still loading, so a caller can tell "not yet known" from "no".
 */
export function useTweaksPanelAccess(): boolean | undefined {
  const { data } = useQuery({
    queryKey: queryKeys.tweaksPanel,
    queryFn: async () =>
      jsonOrThrow<api.TweaksPanelResponse>(
        await client().api.me["tweaks-panel"].$get(),
        "GET /api/me/tweaks-panel",
      ),
    staleTime: 60_000,
    retry: false,
    enabled: !import.meta.env.DEV,
  });
  if (import.meta.env.DEV) return true;
  return data?.enabled;
}
